/* eslint-disable import/no-anonymous-default-export */
export default {
  lists: [],
  list: {},
  jobs: [],
  jobList: [],
  apiCallsInProgress: 0,
};
